import { formatToDdMmYyyy } from '@/utils';
import type {
  LC_MonthlyCutManagementItemOut,
  LC_MonthlyCutsCountersOut,
  LC_MonthlyCutGroupItemOut,
  LC_MonthlyCutDetailOut,
  MonthlyCutManagementItem,
  MonthlyCutsCounters,
  MonthlyCutGroup,
  MonthlyCutDetail,
} from '../types';


export function mapMonthlyCutManagementItem(
  transport: LC_MonthlyCutManagementItemOut,
): MonthlyCutManagementItem {
  const startDate = formatToDdMmYyyy(transport.startDate);
  const endDate = formatToDdMmYyyy(transport.endDate);
  return {
    id: transport.monthlyCutId,
    companyName: transport.companyName,
    year: transport.year,
    month: transport.month,
    startDate,
    endDate,
    range: `${startDate} - ${endDate}`,
    process: transport.process,
    state: transport.state,
    conceptGenerationActive: transport.conceptGenerationActive,
    conceptGenerationProgress: transport.conceptGenerationProgress,
  };
}

export function mapMonthlyCutsCounters(
  transport: LC_MonthlyCutsCountersOut,
): MonthlyCutsCounters {
  return {
    total: transport.totalCount,
    open: transport.openCount,
    closed: transport.closedCount,
  };
}

export function mapMonthlyCutGroupItem(
  transport: LC_MonthlyCutGroupItemOut,
): MonthlyCutGroup {
  return {
    id: transport.groupId,
    name: transport.groupName,
  };
}

// El backend serializa las fechas como DateTime ISO (ej: "2026-07-22T00:00:00").
// Se extrae solo la parte de fecha (yyyy-MM-dd) que es el formato que consume el DatePicker.
export function mapMonthlyCutDetail(
  transport: LC_MonthlyCutDetailOut,
): MonthlyCutDetail {
  return {
    id: transport.monthlyCutId,
    companyId: transport.companyId,
    companyName: transport.companyName,
    year: transport.year,
    month: transport.month,
    startDate: transport.startDate?.split('T')[0] ?? transport.startDate,
    endDate: transport.endDate?.split('T')[0] ?? transport.endDate,
    groupIds: transport.groupIds,
    applyToAllCompanies: transport.applyToAllCompanies,
    state: transport.state,
  };
}
